import { Typography } from "@mui/material";
import reactStringReplace from "react-string-replace";
import { useNumberFormatter } from "src/hooks/formatters/use-number-formatter";

interface IAlphaPerformanceValueProps {
    text: string;
    value: number;
}

export const AlphaWithPerformanceValue = ({ text, value }: IAlphaPerformanceValueProps) => {
    const { formatPerformance } = useNumberFormatter();

    return reactStringReplace(text, "<<performance>>", (_, index) => (
        <Typography component="span" color="teal.600" fontWeight="semibold" key={index}>
            {formatPerformance(value, 1)}
        </Typography>
    ));
};
